import React, { useState, useEffect } from 'react';
import ChildPage from '../components/ChildPage';
import ReusableModal from '../components/ReusableModal';
import { 
  calcModals, 
  showModalContent, 
  hideModalContent 
} from '../helpers/functions';
import BgImage from '../assets/MWC-Services_Start.jpg';
import VideoTransitionIn from '../assets/Transition_Start-Support.mp4';
import VideoBgLoop from '../assets/support/Support_Bg-Loop.mp4';
import VideoTransitionOut from '../assets/Transition_Back-Start.mp4';
import ModalOneSrc from '../assets/support/Support_Carrier-Grade-Support.mp4';
import ModalTwoSrc from '../assets/support/Support_Customer-Story-Telecomms-Comp.jpg';

export default function Support() {
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);

  useEffect(() => {
    // listeners
    window.addEventListener('resize', calcModals);
  }, []);
  
  return (
    <>
      <ChildPage
        BgImage={BgImage}
        VideoTransitionIn={VideoTransitionIn}
        VideoBgLoop={VideoBgLoop}
        VideoTransitionOut={VideoTransitionOut}
      >
        <button onClick={() => setShow1(true)}>
          <div className="position-absolute" style={{width: 20.8 + '%', height: 4 + '%', bottom: 16.8 + '%', left: 63.8 + '%'}}></div>
        </button>
        <ReusableModal
          show={show1}
          handleClose={() => setShow1(false)}
          handleShow={() => setShow1(true)}
          size="xl"
          onEnter={calcModals}
          onEntered={showModalContent}
          onExit={hideModalContent}
        >
          <video 
            src={ModalOneSrc} 
            type="video/mp4" 
            className="w-100" 
            loop
            muted
          />
        </ReusableModal>

        <button onClick={() => setShow2(true)}>
          <div className="position-absolute" style={{width: 15.8 + '%', height: 4 + '%', bottom: 12.1 + '%', left: 63.8 + '%'}}></div>
        </button>
        <ReusableModal
          show={show2}
          handleClose={() => setShow2(false)}
          handleShow={() => setShow2(true)}
          size="xl"
          onEnter={calcModals}
          onEntered={showModalContent}
          onExit={hideModalContent}
        >
          <img 
            src={ModalTwoSrc} 
            alt="Dish Customer Story" 
            className="w-100"
          />
        </ReusableModal>
      </ChildPage>
    </>
  )
}
